import { useCallback, useEffect, useState } from "react";
import {
  getCompatibleCalculatorResults,
  getRecentCalculatorResults,
  saveCalculatorResult,
} from "../utils/calculatorResultStore";

const useCalculatorResults = (targetCalculatorId, targetUnits = "imperial") => {
  const [recentResults, setRecentResults] = useState(() => getRecentCalculatorResults());

  const refresh = useCallback(() => {
    setRecentResults(getRecentCalculatorResults());
  }, []);

  useEffect(() => {
    const handleUpdate = () => refresh();
    window.addEventListener("storage", handleUpdate);
    window.addEventListener("manucalc:calculator-results-updated", handleUpdate);
    return () => {
      window.removeEventListener("storage", handleUpdate);
      window.removeEventListener("manucalc:calculator-results-updated", handleUpdate);
    };
  }, [refresh]);

  const saveResult = useCallback((result) => {
    const saved = saveCalculatorResult(result);
    refresh();
    return saved;
  }, [refresh]);

  return {
    recentResults,
    compatibleResults: targetCalculatorId
      ? getCompatibleCalculatorResults(targetCalculatorId, targetUnits)
      : [],
    saveResult,
    refresh,
  };
};

export default useCalculatorResults;
